import { createInstance, type i18n as I18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from '../locales/en-US/translation.json';

const i18n: I18n = createInstance();
i18n.use(initReactI18next).init({
  // hard coding tests to just english for now
  lng: 'en-US',
  fallbackLng: 'en-US',
  interpolation: {
    // Matches src/i18n.ts. Without this the harness escapes interpolated values and React escapes
    // them again, so an interpolated date renders as "5&#x2F;24&#x2F;26" in tests but not in the app.
    escapeValue: false,
  },
  resources: {
    'en-US': {
      translation: enUS,
    },
    en: {
      translation: enUS,
    },
  },
});

export default i18n;
